import React, { useEffect, useState } from 'react'
import VerticalProgBar from '../Pending/VarticalProgressBar/VerticalProgBar'
// import AdaptiveEvalutionGraph from './AdaptiveEvalutionGraph';
// import "./"

function CompletedAdaptiveQues() {
    const [difficulty, setDifficulty] = useState(0);
    const [skills, setSkills] = useState(0);
    const [openGraphPopup, setOpenGraphPopup] = useState(false)

    const difficultyLevels = ["Very Hard", "Hard", "Medium", "Easy", "Very Easy"];
    const skillsLevels = [
        "Create",
        "Evaluate",
        "Analyze",
        "Apply",
        "Understand",
        "Remember",
    ];

    useEffect(() => {
        const updateProgress = () => {
            setDifficulty(Math.floor(Math.random() * 101)); // Random between 0-100
            setSkills(Math.floor(Math.random() * 101));
        };
        updateProgress()
    }, [])

    const showSummary = {
        background: "#F77F00",
        fontSize: "16px",
        padding: "11px 14px",
        fontWeight: "600",
        borderRadius: "5px",
        border: "none",
        color: '#fff'
    }
    return (
        <div className="ContainerQuestion d-flex p-4 gap-1">
            <div>
                <img
                    style={{ cursor: "pointer" }}
                    onClick={() => window.history.back()}
                    src="/HwImg/backArrow.png"
                    alt=""
                />{" "}
                &nbsp;
            </div>
            <div className="hederContainer1">
                <div>
                    <div className="d-flex justify-content-between w-100  mb-4">
                        <div className="d-flex">
                            <div className="quesHeading">
                                {/* {studentResultData?.assessment?.name} */}
                                {`Completed Assessment`}
                            </div>
                            <div className="penddingButton ml-2">Completed</div>
                        </div>
                        <div>
                            <div>
                                <span className="subTitles">
                                    <button style={showSummary} onClick={() => setOpenGraphPopup(true)}>Show Summary</button>
                                </span> &nbsp;
                                {/* <span className="quesHeading">
                                    {studentResult?.obtained_marks}/
                                    {studentResult?.assessment?.total_marks}
                                </span> */}
                            </div>
                            {/* <div style={{ textAlign: "end" }}>
                                &nbsp; <span className="subTitles">This Question</span>{" "}
                                &nbsp;
                                <span className="quesHeading">
                                    {studentResult?.assessment?.total_questions.toString().padStart(2, '0')}
                                    {resultData[questionNo]?.question_response?.question?.correct_score}
                                </span>
                            </div> */}
                        </div>
                    </div>
                    <div className="d-flex justify-content-between w-100 mt-2 mb-2">
                        <div className="d-flex">
                            <div>
                                <span className="subTitle2">
                                    {/* {studentResultData?.assessment?.subject_id?.name} */}
                                    {`Englsih`}
                                </span>
                                &nbsp;
                                <span>|</span> &nbsp;
                                <span className="subTitles3">Scheduled</span> &nbsp;
                                <span className="subTitle2">
                                    {/* {timeHelper(studentResultData?.assessment?.deadline)} */}
                                    {`11/01/2025`}
                                </span>
                                &nbsp;
                            </div>

                        </div>
                        {/* <div className="subTitle2">
                  Questions: {questionNo + 1}/{resultData?.length}
                </div> */}
                    </div>
                </div>
                <div className="mt-3 d-flex gap-2" style={{ overflowX: "auto" }}>
                    {/* {resultData?.length > 0 &&
                        resultData?.map((item, index) => (
                            <div
                                onClick={(e) => setQuestionNo(index)}
                                className={
                                    questionNo > index
                                        ? "QuestionActiveNo"
                                        : "QuestionNoNonActive"
                                }
                                style={{
                                    borderColor: item.question_response.question.is_mandatory
                                        ? "#AC1616"
                                        : questionNo === index
                                            ? "#F99933"
                                            : questionNo > index
                                                ? "#F77F00"
                                                : "#668598",
                                    color:
                                        questionNo === index
                                            ? "#F99933"
                                            : questionNo > index
                                                ? "#F77F00"
                                                : "#668598",
                                    backgroundColor:
                                        questionNo > index ? "#FEF2E5" : "transparent",
                                    minWidth: "30px",
                                }}
                            >
                                Q{index + 1}
                            </div>
                        ))} */}
                </div>
                <div className="mt-4">
                    {/* <div className='Question'>Q1. .?</div> */}
                    {/* <div className='Question'>Q{questionNo + 1}.&nbsp; {list[questionNo].title}</div> */}
                    {/* <div className='Question'>{list[questionNo].dec}</div> */}

                    {/* {list[questionNo].type === "Img Type" && (
                <ImgType questionNo={questionNo + 1} />
              )}
              {list[questionNo].type === "Video Type" && (
                <VideoType questionNo={questionNo + 1} />
              )}
              {list[questionNo].type === "TextArea Type" && (
                <TextareaType questionNo={questionNo + 1} />
              )}
              {list[questionNo].type === "Pdf Type" && (
                <PdfType questionNo={questionNo + 1} />
              )}
              {list[questionNo].type === "Checkbox Type" && (
                <CheckBoxType questionNo={questionNo + 1} />
              )}
              {list[questionNo].type === "Upload Type" && (
                <SubmisshionByUpload questionNo={questionNo + 1} />
              )} */}
                    <div className="mt-4 allquestionTypesContainer row" style={{ height: "75%" }}>
                        <div className="col-6">
                            {/* {!resultData[questionNo]?.question_response?.question?.type
                        ?.is_manually_graded ? (
                        <CheckBoxType
                            questionNo={questionNo + 1}
                            response={resultData[questionNo]}
                        />
                    ) : (
                        <SubmisshionByUpload
                            questionNo={questionNo + 1}
                            response={resultData[questionNo]}
                        />
                    )} */}
                        </div>
                        <div className="col-6">
                            <div style={{ display: "flex", justifyContent: "center" }}>
                                <VerticalProgBar
                                    title="Difficulty"
                                    levels={difficultyLevels}
                                    progress={difficulty}
                                />
                                <VerticalProgBar
                                    title="Skills"
                                    levels={skillsLevels}
                                    progress={skills}
                                />
                            </div>
                        </div>
                    </div>



                    <div>
                        <div className=" MarkAndQueContainerAssignment ">
                            <div className="quesHeading d-flex justify-content-start">
                                {/* 01 / 25 */}
                                {/* {questionNo + 1}/{resultData?.length} */}
                            </div>
                            {/* <div>
                                <span className="subTitles">Total Marks</span> &nbsp;
                                <span className="quesHeading">
                                    {studentResultData?.obtained_marks} out of{" "}
                                    {studentResultData?.assessment?.total_marks}
                                </span>
                            </div> */}
                            <div>
                                {/* <span className="subTitles">This Question Marks</span>{" "}
                                &nbsp;
                                <span className="quesHeading">
                                    {resultData[questionNo]?.obtained_marks} out of{" "}
                                    {
                                        resultData[questionNo]?.question_response?.question
                                            ?.correct_score
                                    }
                                </span> */}
                            </div>
                        </div>
                        <div className="d-flex gap-2 justify-content-end nextBtnContainer">
                            {/* {questionNo >= 1 && (
                                <button
                                    className="PreviousBtnQue"
                                    onClick={(e) => setQuestionNo(questionNo - 1)}
                                >
                                    Previous
                                </button>
                            )}

                            {resultData?.length > questionNo + 1 && (
                                <button
                                    className="nextBtnQue"
                                    onClick={(e) => setQuestionNo(questionNo + 1)}
                                >
                                    Next
                                </button>
                            )} */}
                            <button
                                className="PreviousBtnQue"
                            // onClick={(e) => setQuestionNo(questionNo - 1)}
                            >
                                Previous
                            </button>
                            <button
                                className="nextBtnQue"
                            // onClick={(e) => setQuestionNo(questionNo + 1)}
                            >
                                Next
                            </button>
                        </div>
                    </div>
                </div>
            </div>
            {
                // openGraphPopup && (
                //     <AdaptiveEvalutionGraph setOpenGraphPopup={setOpenGraphPopup} />
                // )
            }
        </div>
    )
}

export default CompletedAdaptiveQues